import React from 'react';
import { X } from 'lucide-react';
import './ConfirmModal.css';

// Modale di conferma in stile col sito (sostituisce window.confirm/alert).
// Props: open, title, message, confirmLabel, cancelLabel, onConfirm, onClose, icon.
function ConfirmModal({
  open,
  title,
  message,
  confirmLabel = 'Conferma',
  cancelLabel = 'Annulla',
  onConfirm,
  onClose,
  icon = null,
  variant = 'primary', // 'primary' | 'danger'
}) {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" onClick={onClose} aria-label="Chiudi">
          <X size={20} />
        </button>
        {icon && <div className="modal-icon">{icon}</div>}
        {title && <h3 className="modal-title">{title}</h3>}
        {message && <p className="modal-message">{message}</p>}
        <div className="modal-actions">
          {cancelLabel && (
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              {cancelLabel}
            </button>
          )}
          <button
            type="button"
            className={`btn ${variant === 'danger' ? 'btn-danger' : 'btn-primary'}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
